import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType } from '../types'
import { getCheckNumber } from './Component'
import {
  MaxdiffQuestionModelTypes,
  IMaxdiffQuestionModelState,
  IMaxdiffResponseValidation,
  MaxdiffSmallFrame,
  MaxdiffSubmitResponse,
  MaxdiffCheckResponse
} from './types'

export const checkAnswers = (num: number) => {
  switch (num) {
    case 3:
      return ['best', 'worst', 'empty1']
    case 4:
      return ['best', 'worst', 'empty1', 'empty2']
    default:
      return ['best', 'worst', 'empty1', 'empty2', 'empty3']
  }
}

export const checkAnswersRanking = (num: number) => {
  switch (num) {
    case 3:
      return ['1', '2', '3']
    case 4:
      return ['1', '2', '3', '4']
    default:
      return ['1', '2', '3', '4', '5']
  }
}

const makeFrame = (id: string): MaxdiffSmallFrame => {
  const a: MaxdiffSmallFrame = { id: id }
  return a
}

const MaxdiffQuestionModel: IQuestionModelConstructor<MaxdiffQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<MaxdiffQuestionModelTypes, IMaxdiffQuestionModelState>({
    questionType: QuestionType.MAXDIFF,
    questionSchema: questionSchema,
    action,
    submitResponse,
    checkResponse,
    initState,
    validateResponse
  })
  model.navigationFrame = [1, model.schema.answers_mask.length]
  return model
}

function checkResponse({ response, questionSchema }: IMaxdiffQuestionModelState): MaxdiffCheckResponse {
  return response.checkShown
    ? {
        response: [
          { id: response.checkResponse.best },
          ...checkAnswers(questionSchema.items_per_question)
            .filter(id => id != response.checkResponse.best && id != response.checkResponse.worst)
            .map(id => makeFrame(id)),
          { id: response.checkResponse.worst }
        ],
        position: response.checkNumber
      }
    : { response: [], position: undefined }
}

function submitResponse({ response, questionSchema }: IMaxdiffQuestionModelState): MaxdiffSubmitResponse {
  const empty: MaxdiffSubmitResponse = []
  const a = response.frames.reduce((prev, cur, frame) => {
    const answers = questionSchema.answers_mask[frame]
      .filter(answer => answer != cur?.best && answer != cur?.worst)
      .map(id => makeFrame(id))
    prev[frame] = cur && prev ? [{ id: cur?.best }, ...answers, { id: cur?.worst }] : [...answers]
    return prev
  }, empty)
  return a
  // checkSum: response.checkShown
  //     ? [
  //         { id: response.checkResponse.best },
  //         ...CHECK_ANSWERS.filter(id => id != response.checkResponse.best && id != response.checkResponse.worst).map(
  //           id => makeFrame(id)
  //         ),
  //         { id: response.checkResponse.worst }
  //       ]
  //     : []
}

function initState(state: IMaxdiffQuestionModelState): IMaxdiffQuestionModelState {
  state.response = {
    frames: [],
    checkResponse: {},
    checkShown: false,
    checkNumber: getCheckNumber(state.questionSchema)
  }
  return state
}

function validateResponse({ questionSchema, response, frame }: IMaxdiffQuestionModelState): IMaxdiffResponseValidation {
  if (!questionSchema.answers.length)
    return {
      valid: true
    }

  if (
    questionSchema.check &&
    !response.checkShown &&
    frame === response.checkNumber &&
    response.checkResponse.best &&
    response.checkResponse.worst
  )
    return {
      valid: true
    }

  if (response.frames[frame as number]?.best && response.frames[frame as number]?.worst)
    return {
      valid: true
    }

  return {
    valid: false
  }
}

export default MaxdiffQuestionModel
